t = require('app/scripts/views/internal/teacup-with-helpers')('header_two_factor_backups_banner')

module.exports = ->
  t.p '.u-bottom', ->
    t.format 'generate-new-backup-codes'
